import { render, staticRenderFns } from "./deleteButton.vue?vue&type=template&id=ab91bc14&scoped=true"
import script from "./deleteButton.vue?vue&type=script&lang=js"
export * from "./deleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab91bc14",
  null
  
)

export default component.exports